import React from 'react';
import ReactDOM from 'react-dom';
//import './bootstrap.min.css'
import './index.css';
import App from './App';
import {Provider} from 'react-redux'
import store from './store'
import { EventProvider } from './screens/EventContext';

/*
if (window.Shopline.customer === "" || window.Shopline.customer === undefined) {
  let vc = window.confirm("Please login before to access gift registry.");
  console.log("------------------------VC VALUE **************************************");
  console.log(vc);
  if(vc === true){
    window.location.href = `https://${window.Shopline.handle}.myshopline.com/user/signIn`;    
  }
}
*/

ReactDOM.render(  
  <Provider store={store}>    
    <EventProvider>
    <App />
    </EventProvider>
  </Provider>,
  document.getElementById('root')
);
